import * as React from "react";
import { makeStyles, mergeClasses, Switch, SwitchOnChangeData, SwitchProps } from "@fluentui/react-components";

const useStyles = makeStyles({
    switchBase: {
        display: "inline-flex",
        alignItems: "center",

        "& .fui-Switch__label": {
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "12px",
        },
        "& .fui-Switch__label .fui-Text": {
            fontSize: "12px",
        },
        "& .fui-Switch__label svg": {
            fontSize: "12px",
            width: "12px",
            height: "12px",
        },
        "& .fui-Switch__indicator": {
            margin: "0px",
            transform: "scale(0.86)",
            transformOrigin: "left center",
        },
    },
    switchEnabled: {
        "& *": {
            cursor: "pointer",
        },
    },
});

export interface NewformaSwitchProps {
    checked?: boolean;
    disabled?: boolean;
    label?: React.ReactNode;
    labelPosition?: SwitchProps["labelPosition"];
    className?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, data: SwitchOnChangeData) => void;
    dataTestId?: string;
}

export const NewformaSwitch: React.FC<NewformaSwitchProps> = ({
    checked,
    disabled,
    label,
    labelPosition,
    className,
    onChange,
    dataTestId,
}) => {
    const styles = useStyles();

    return (
        <Switch
            checked={checked}
            disabled={disabled}
            label={label as SwitchProps["label"]}
            labelPosition={labelPosition}
            onChange={onChange}
            className={mergeClasses(styles.switchBase, !disabled && styles.switchEnabled, className)}
            data-testid={dataTestId}
        />
    );
};
